export default __webpack_public_path__ + "static/media/F0007.e58f03e5.png";